import ReactTooltip from 'react-tooltip';
import styled, { DefaultTheme } from 'styled-components/macro';

type TTextAlign = 'left' | 'right' | 'center' | 'justify' | 'initial' | 'inherit';

export const CustomTooltip = styled(ReactTooltip)<{
  type?: string;
  width?: string;
  maxWidth?: string;
  textAlign?: TTextAlign;
}>`
  padding: ${({ theme }) => theme.spacing.zero_2} !important;
  border-radius: 8px !important;
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  font-size: ${({ theme }) => theme.fontSize.xxs} !important;
  line-height: 1.33;
  text-align: center;
  box-shadow: 0 2px 10px -2px rgba(37, 40, 43, 0.2);

  :before {
    z-index: -1 !important;
  }

  ${({ type }) =>
    !type &&
    `
      background-color: ${({ theme }: { theme: DefaultTheme }) =>
        theme.colors.black_100} !important;

      :after {
        background-color: ${({ theme }: { theme: DefaultTheme }) =>
          theme.colors.black_100} !important;
      }
    `}

  ${({ width }) =>
    width &&
    `
      width: ${width};
    `}

    ${({ maxWidth }) =>
    maxWidth &&
    `
      max-width: ${maxWidth};
    `}


    ${({ textAlign }) =>
    textAlign &&
    `
      text-align: ${textAlign};
    `}

  @media only screen and (max-width: 1440px) {
    margin-left: -${({ theme }) => theme.spacing.one} !important;
  }
`;
